import { X } from 'lucide-react';
import { useFitnessStore } from '../../../store/fitnessStore';

export default function ExerciseModal() {
  const modal = useFitnessStore((s) => s.modal);
  const closeModal = useFitnessStore((s) => s.closeModal);
  if (modal?.type !== 'exercise') return null;
  const exercise = modal.data;

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 100, display: 'flex', alignItems: 'flex-end', backdropFilter: 'blur(6px)' }}
      onClick={closeModal}
      role="presentation"
    >
      <div style={{ background: '#141416', borderRadius: '20px 20px 0 0', width: '100%', maxHeight: '85vh', overflowY: 'auto', padding: 20 }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 style={{ fontFamily: 'Bebas Neue', fontSize: 24, textTransform: 'capitalize', margin: 0 }}>{exercise?.name}</h2>
          <button type="button" onClick={closeModal} style={{ background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: 8, padding: 8, cursor: 'pointer', color: '#fff' }}><X size={18} /></button>
        </div>
        {exercise?.gifUrl && (
          <img src={exercise.gifUrl} alt={exercise.name} style={{ width: '100%', maxHeight: 280, objectFit: 'contain', borderRadius: 12, marginBottom: 16, background: '#1C1C1F' }} />
        )}
        <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
          {exercise?.target && <span style={{ fontSize: 11, padding: '4px 10px', borderRadius: 20, background: 'rgba(232,255,71,0.12)', color: '#E8FF47', fontWeight: 600 }}>{exercise.target}</span>}
          {exercise?.equipment && <span style={{ fontSize: 11, padding: '4px 10px', borderRadius: 20, background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.5)' }}>{exercise.equipment}</span>}
          {exercise?.bodyPart && <span style={{ fontSize: 11, padding: '4px 10px', borderRadius: 20, background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.5)' }}>{exercise.bodyPart}</span>}
        </div>
        {exercise?.instructions?.length > 0 && (
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.4)', letterSpacing: 1, marginBottom: 10 }}>INSTRUCTIONS</div>
            {exercise.instructions.map((step, i) => (
              <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 10, alignItems: 'flex-start' }}>
                <div style={{ width: 22, height: 22, borderRadius: 6, background: 'rgba(232,255,71,0.12)', color: '#E8FF47', fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{i + 1}</div>
                <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.75)', lineHeight: 1.5 }}>{step}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
